import { PERMISSIONS } from '../constants/permissions';
import { hasPermission } from '../utils/permissions';

/**
 * Work-policy module capabilities from mounted arkhrmsapi routes.
 *
 * Mounted:
 * - GET /work-policies (search + pagination)
 * - POST /work-policies
 * - PUT /work-policies/:workPolicyId
 *
 * Not mounted:
 * - GET /work-policies/:workPolicyId (details use search ownership)
 * - DELETE /work-policies/:workPolicyId
 * - Weekly-off CRUD on the policy itself (employee weekly-off is separate)
 *
 * Installed permissions are SETTINGS_VIEW and SETTINGS_UPDATE.
 * Swagger labels WORK_POLICY.READ/CREATE/UPDATE map to those codes.
 */
export const WORK_POLICY_ROUTE_CAPABILITIES = {
  list: true,
  create: true,
  update: true,
  detailsById: false,
  delete: false,
} as const;

export type WorkPolicyModuleCapabilities = {
  canViewWorkPolicies: boolean;
  canCreateWorkPolicy: boolean;
  canUpdateWorkPolicy: boolean;
};

export function getWorkPolicyModuleCapabilities(
  permissions: readonly string[],
): WorkPolicyModuleCapabilities {
  const canView = hasPermission(permissions, PERMISSIONS.SETTINGS_VIEW);
  const canUpdate = hasPermission(permissions, PERMISSIONS.SETTINGS_UPDATE);

  return {
    canViewWorkPolicies: canView && WORK_POLICY_ROUTE_CAPABILITIES.list,
    canCreateWorkPolicy: canUpdate && WORK_POLICY_ROUTE_CAPABILITIES.create,
    canUpdateWorkPolicy: canUpdate && WORK_POLICY_ROUTE_CAPABILITIES.update,
  };
}
